import { render, staticRenderFns } from "./InputRadioBasic.vue?vue&type=template&id=ea58489e"
import script from "./InputRadioBasic.vue?vue&type=script&lang=js"
export * from "./InputRadioBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports